package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SetupPaymentIntentRequest(
    @SerialName("paymentMethods") var paymentMethods: List<String>? = null,
    @SerialName("customerId") var customerId: String? = null
)